import axios, { AxiosRequestConfig, AxiosRequestHeaders } from 'axios';
import { baseUrl } from '../constatnts/Connections';
import { handleSuccess, handleError } from './server';

export const getImage = (imageId: string) => `${baseUrl}/common/file/${imageId}`;

export async function uploadFile(file: any) {
	const token = await localStorage.getItem('accessToken');
	const formData = new FormData();
	formData.append('file', file);
	const options: AxiosRequestConfig = {
		method: 'POST',
		url: `${baseUrl}/common/file/upload`,
		headers: {
			Authorization: `Bearer ${token}`,
			'Content-Type': 'multipart/form-data',
		},
		data: formData,
	};
	return axios(options)
		.then((response) => handleSuccess(response))
		.catch((error) => handleError(error));
}

export async function uploadFiles(filesArray: any) {
	const token = await localStorage.getItem('accessToken');
	const formData = new FormData();
	filesArray.forEach((element: any) => {
		formData.append('files', element);
	});
	const options: AxiosRequestConfig = {
		method: 'POST',
		url: `${baseUrl}/common/files/upload`,
		headers: {
			Authorization: `Bearer ${token}`,
			'Content-Type': 'multipart/form-data',
		},
		data: formData,
	};
	return axios(options)
		.then((response) => handleSuccess(response))
		.catch((error) => handleError(error));
}

export async function deleteFiles(data: any) {
	const token = localStorage.getItem('accessToken');
	const options: AxiosRequestConfig = {
		method: 'POST',
		url: `${baseUrl}/common/files/bulk-delete`,
		headers: {
			Authorization: `Bearer ${token}`,
		},
		data: data,
	};
	return axios(options)
		.then((response) => handleSuccess(response))
		.catch((error) => handleError(error));
}

export async function editFile(id: any, file: any) {
	const token = await localStorage.getItem('accessToken');

	const formData = new FormData();
	formData.append('id', id);
	formData.append('file', file);

	const options: AxiosRequestConfig = {
		method: 'PUT',
		url: `${baseUrl}/admin/file/edit`,
		headers: {
			Authorization: `Bearer ${token}`,
			'Content-Type': 'multipart/form-data',
		},
		data: formData,
	};
	return axios(options)
		.then((response) => handleSuccess(response))
		.catch((error) => handleError(error));
}
export async function getGallery(limit?: any, offset?: any, term?: any) {
	const token = localStorage.getItem('accessToken');
	const options: AxiosRequestConfig = {
		method: 'GET',
		url: `${baseUrl}/common/gallery?term=${term}&limit=${limit}&offset=${offset}`,
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return axios(options)
		.then((response) => handleSuccess(response))
		.catch((error) => handleError(error));
}
